import { DateTime, Duration, DurationObject, DurationObjectUnits, Interval } from "luxon"

export interface CountdownData {
    days: string | number | undefined;
    hours: string | number | undefined;
    minutes: string | number | undefined;
}

type DurationObjectUnitsParam =  keyof DurationObjectUnits | (keyof DurationObjectUnits)[] | undefined;

export const getCountdownData = (data: DurationObject) => {
    return {
        days: (data.days || 0) > 9 ? data.days : '0' + data.days,
        hours: (data.hours || 0) > 9 ? data.hours : '0' + data.hours,
        minutes: (data.minutes || 0) > 9 ? data.minutes : '0' + data.minutes,
        seconds: (data.seconds || 0) > 10 ? data.seconds && Math.floor(data.seconds) : Duration.fromObject({ seconds: data.seconds }).toFormat("ss"),
    }
}

export const getDurationObject = (from: DateTime, to: DateTime, fields: DurationObjectUnitsParam = ['days', 'hours', 'minutes', 'seconds']) => {
    return Interval.fromDateTimes(from, to).toDuration(fields).toObject()
}

/**
 * Get duration object from now to date from params
 * @param to date duration to
 * @param fields fields needed in object
 * @returns duration object
 */
export const getDurationObjectFromNow = (to: DateTime, fields: DurationObjectUnitsParam = ['days', 'hours', 'minutes', 'seconds']) => {
    return getDurationObject(DateTime.local(), to, fields);
}